import { Bars3Icon } from "@heroicons/react/24/outline";
import { withPrefix } from "gatsby";
import React, { useState } from "react";

import { MobileNav } from "./../MobileNav/index";
import { NavDataProps } from "../../types";
import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/solid";
import { ChristieInsuranceLogoWhite } from "../../../assets/icons/ChristieInsuranceLogoWhite";

export const MobileHeader = ({ navData }: NavDataProps) => {
  const [activeId, setActiveId] = useState<string | null>(null);
  const handleActiveId = (id: string | null = null): void => {
    setActiveId(id === activeId ? null : id);
  };
  const phone = navData?.phone?.value;
  const email = navData?.email?.value;

  return (
    <section className="block lg:hidden shadow-lg ">
      <div className="flex justify-between bg-lime-500 text-white h-16 pr-2">
        {/* LOGO */}
        <div className="flex flex-col justify-center items-center ml-3 mr-6 sm:mx-6">
          <a href={withPrefix("/")}>
            <ChristieInsuranceLogoWhite className="h-8 sm:h-10" />
          </a>
        </div>

        {/* RIGHT MENU */}

        {phone && (
          <a
            href={"tel:" + phone}
            className="text-lg font-semibold hover:text-lime-600 hover:decoration-2 hover:underline-offset-2 flex items-center gap-2"
          >
            <PhoneIcon className="size-6" />
          </a>
        )}
        {email && (
          <a
            href={"mailto:" + email}
            className="hidden sm:flex text-lg font-semibold hover:text-lime-600 hover:decoration-2 hover:underline-offset-2 flex items-center gap-2"
          >
            <EnvelopeIcon className="size-6" />
          </a>
        )}

        <button className="block" onClick={() => handleActiveId("open")}>
          <Bars3Icon className="size-8" />
          <span className="sr-only">Menu</span>
        </button>

        {/* SIDE MENU */}
        {activeId && (
          <MobileNav
            activeId={activeId}
            handleActiveId={handleActiveId}
            navData={navData}
          />
        )}
      </div>
    </section>
  );
};
